import React from 'react';

import { Box, Center, Stack, Text, useMantineTheme } from '@mantine/core';
import { ChatConversationView } from 'components/SmartAssistantComponents/ChatConversationView';
import { ChatHeader } from 'components/SmartAssistantComponents/ChatHeader';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { ToolVisibilityOverrides } from 'hooks/use-tool-visibility';
import { useTranslation } from 'react-i18next';
import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';
import { ToolConfig } from 'shared/interfaces/tools/Tool';

interface DroxyChatPreviewContainerProps {
  messages: ChatMessage[];
  toolConfigs?: ToolConfig[];
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  height?: number;
  width?: number;
  visibilityOverrides?: ToolVisibilityOverrides;
  inputTopSection?: React.ReactNode;
}

export function DroxyChatPreviewContainer({
  messages,
  toolConfigs,
  smartAssistantVisualConfig,
  height = 600,
  width = 400,
  visibilityOverrides,
  inputTopSection
}: DroxyChatPreviewContainerProps) {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const [subscription] = useSubscriptionContext();

  return (
    <Stack>
      <Box w={width} h={height} style={{ borderRadius: 16, overflow: 'hidden' }}>
        <ChatConversationView
          messages={messages}
          viewMode="preview"
          toolConfigs={toolConfigs || []}
          smartAssistantId="preview"
          smartAssistantVisualConfig={smartAssistantVisualConfig}
          header={<ChatHeader smartAssistantVisualConfig={smartAssistantVisualConfig} justify="flex-start" />}
          displayPoweredBy={!subscription.product.removePoweredBy}
          disableAnimation
          visibilityOverrides={visibilityOverrides}
          inputTopSection={inputTopSection}
        />
      </Box>
      <Center>
        <Text color={theme.colors.gray[4]}>{t('SMART_ASSISTANT.TOOLS_SECTION.PREVIEW.CLARIFICATION')}</Text>
      </Center>
    </Stack>
  );
}
